import classNames from 'classnames';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import styles from "./Filter.module.css";

export const FilterWrapper = ({ children, showFilters, layoutConfig, className, isDesktop }) => {
    const threeColLayout = layoutConfig === '3-Col';
    const w = !isDesktop ? '100%' : !threeColLayout ? 'calc((100% / 12 * 5) + (40px / 12 * 5) - 40px)' : (!showFilters && threeColLayout) ? 'calc(0%)' : 'calc((100% / 12 * 4) + (40px / 12 * 4 - 40px))';

    return (
        <>
            <motion.div
                animate={{
                    minWidth: w,
                    width: w === 'calc(0%)' ? 'calc(0%)' : w,
                    opacity: w === 'calc(0%)' ? 0 : 1,
                    x: w === 'calc(0%)' ? -500 : 0
                }}
                transition={{ type: "tween", duration: 0.5 }}
                id="filterWrapper" className={classNames(className, styles.filterWrapper, { threeColLayout: threeColLayout }, { showFilters: showFilters })}>
                <div className="filterContentWrapper">
                    {children}
                </div>
            </motion.div>
        </>
    )
} 
